import styled from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

export const ScJackpotSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  & > .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 544px;
    width: 100%;
    gap: 16px;

    & > .logo {
      max-width: 364px;
      width: 100%;

      img {
        width: 100%;
        height: auto;
      }
    }

    & > .text {
      text-transform: uppercase;
      text-align: center;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .title {
        font-size: 22px;
        line-height: 1.27;
        letter-spacing: 0.02em;
        color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
      }
      .prize {
        font-size: 56px;
        line-height: 1;
        letter-spacing: 0.03em;
        color: ${({ theme }) => theme.whiteColor};
      }
    }
  }

  & > .pools {
    width: 100%;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(3, 1fr);
  }

  @media (${device.mobile}) {
    & > .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 100%;

      & > .logo {
        max-width: 292px;
      }

      & > .text {
        gap: 2px;

        .title {
          font-size: 20px;
          line-height: 1.3;
        }

        .prize {
          font-size: 48px;
          line-height: 1.17;
        }
      }
    }

    & > .pools {
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(2, 1fr);
    }
  }
`;
